import { render } from "./BuyMethModal.vue?vue&type=template&id=0fc74a64"
import script from "./BuyMethModal.vue?vue&type=script&lang=js"
export * from "./BuyMethModal.vue?vue&type=script&lang=js"

import "./BuyMethModal.vue?vue&type=style&index=0&id=0fc74a64&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__